import './plugins/datadog/early-init';
import Vue from 'vue';
import Moment from 'moment';
import Money from 'v-money';
import VueCookies from 'vue-cookies';
import VeeValidate, { Validator } from 'vee-validate';
import VueAnalytics from 'vue-analytics';
import vueDebounce from 'vue-debounce';
import Swal from 'sweetalert2';
import App from './App.vue';
import http from './http';
// import './registerServiceWorker'
import router from './router';
import store from './store';
import { locale, validators } from './validations';
import { getUserData, hasUserData } from './helpers/user';
import {
  identifyDatadogUser,
  installDatadogHttpTracking,
  isDatadogRumActive,
  setupDatadogGlobalTracking,
} from './plugins/datadog/rum';

// sweetalert2.all.js injeta CSS com body.swal2-height-auto { height: auto !important },
// o que quebra layouts baseados em height: 100% (ex.: login + modal 2FA).
const originalSwalFire = Swal.fire.bind(Swal);
Swal.fire = (...args) => originalSwalFire({
  ...Swal.argsToParams(args),
  heightAuto: false,
});
const swalHeightFix = document.createElement('style');
swalHeightFix.setAttribute('data-swal-height-fix', 'true');
swalHeightFix.textContent = 'html.swal2-height-auto, body.swal2-height-auto { height: 100% !important; min-height: 100% !important; }';
document.head.appendChild(swalHeightFix);

Vue.prototype.$http = http;
Vue.prototype.$moment = Moment;

Object.entries(validators).forEach(([key, value]) => Validator.extend(key, value));
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA,
  router,
  autoTracking: {
    pageviewTemplate(route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href
      };
    }
  }
});
Vue.use(vueDebounce, {
  listenTo: 'oninput'
});
Vue.use(Money, {
  decimal: ',',
  masked: false,
  precision: 2,
  prefix: 'R$ ',
  thousands: '.'
});
Vue.use(VueCookies);
Vue.use(VeeValidate, locale);

Vue.config.productionTip = false;

if (isDatadogRumActive()) {
  setupDatadogGlobalTracking(Vue);
  installDatadogHttpTracking(http);

  if (hasUserData()) {
    identifyDatadogUser(getUserData());
  }
}

new Vue({ router, store, render: h => h(App) }).$mount('#app');
